
export default {
  name: 'ProductListingDisplayModeSwitcher',

  props: {
    compactDisplayMode: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {
      isDetailDisplayModeHovered: false,
      isCompactDisplayModeHovered: false,
    };
  },

  methods: {
    toggleDetailDisplayMode() {
      this.$emit('toggle-detail-display-mode');
    },

    toggleCompactDisplayMode() {
      this.$emit('toggle-compact-display-mode');
    },
  },
};
